import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

import { ILicenseBulkDiscount } from '../Interface/license'
import { CoreEnvironmentService } from './core-environment.service'

@Injectable()
export class LicensesBulkDiscountService {
  licenseDiscountSubject: BehaviorSubject<ILicenseBulkDiscount[]> = new BehaviorSubject([])
  baseUrl: string

  constructor(
    private http: HttpClient,
    private coreEnvironmentService: CoreEnvironmentService
  ) {
    this.baseUrl = this.coreEnvironmentService.getBaseURL()
  }

  getLicensesDiscount(beatmakerId: number): void {
    this.http.get<ILicenseBulkDiscount[]>(`${this.baseUrl}/web/v1/discounts/bulk/${beatmakerId}`).subscribe(res => {
      this.licenseDiscountSubject.next(res)
    })
  }
}
